import * as React from "react";
import styled from "styled-components";
import Header from "../components/header/index";
import Cotizador from "../components/home/cotizador/index";
import Cubrimos from "../components/home/cubrimos/index";
import Pasos from "../components/home/pasos/index";
import Asistencia from "../components/home/asistencia";
import Carousel from "../components/home/carouseles";
import BicisAseguradas from "../components/home/bicisAseguradas/index";
import Comunicacion from "../components/home/comunicacion";
import Beneficios from "../components/home/beneficios/index";
import Questions from "../components/home/preguntasFrecuentes/index";
import SeguroParaTodos from "../components/footer/seguroParaTodo";
import Footer from "../components/footer/index";

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;
  background-color: var(--white);
  overflow: hidden;
`;

export default function Home() {
  return (
    <Container>
      {/* Header */}
      <Header></Header>
      {/* Cotizador */}
      <Cotizador></Cotizador>
      {/* Cosas que cubre el seguro */}
      <Cubrimos></Cubrimos>
      {/* Pasos para contratar el seguro */}
      <Pasos></Pasos>
      {/* Asistencia Ike */}
      <Asistencia></Asistencia>
      {/* Carousel con banner */}
      <Carousel></Carousel>
      {/* Bicis que aseguramos */}
      <BicisAseguradas></BicisAseguradas>
      {/* Beneficios del seguro */}
      <Beneficios></Beneficios>
      {/* Comunicacion */}
      <Comunicacion></Comunicacion>
      {/* Preguntas frecuentes */}
      <Questions></Questions>
      {/* Seguros para todos */}
      <SeguroParaTodos></SeguroParaTodos>
      {/* Footer */}
      <Footer></Footer>
    </Container>
  );
}
